import { Component, OnInit } from '@angular/core';
import { DYNCONTENT } from '../content-array';
import * as fileSaver from 'file-saver';
import { FileService } from '../file.service';

declare var $: any;

@Component({
  selector: 'app-whoweare',
  templateUrl: './whoweare.component.html',
  styleUrls: ['./whoweare.component.css']
})

export class WhoweareComponent implements OnInit {
  dynContent = DYNCONTENT;
  
  constructor(private fileService: FileService) {}

  download() {
    this.fileService.downloadFile().subscribe(response => {
      let blob:any = new Blob([response.blob()], { type: 'application/pdf' });
      fileSaver.saveAs(blob, 'CFF_donate_by_mail_form.pdf');
      // this part for opening new window with file
      // const url= window.URL.createObjectURL(blob);
      // window.open(url);
      // window.location.href = response.url;      
    })
  }

  ngOnInit() {    
    $(document).ready(function(){
      $.getScript("../assets/carouselengine/amazingcarousel.js");
      $.getScript("../assets/carouselengine/initcarousel-1.js");
      $('#carousel1Controls').carousel();      
    });
  }
}
